var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("type-to-see " + (_vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: 'calc(100% - 50px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    class: {
      isMobileView: _vm.isMobile
    },
    staticStyle: {
      "height": "100%",
      "position": "relative"
    },
    attrs: {
      "slot": "content",
      "id": "sub-content-container"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "top-to-bottom-reveal-container block-container"
  }, _vm._l(_vm.groupedBlocks, function (block, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      style: {
        height: ((100 / _vm.groupedBlocks.length) + "%"),
        'min-height': index === _vm.groupedBlocks.length - 1 ? 'auto' : '90px'
      },
      attrs: {
        "id": ("block-" + index)
      }
    }, _vm._l(block, function (step, stepIndex) {
      return _c('div', {
        key: step.id,
        staticClass: "block-paragraph"
      }, [_c('blinking-cursor-text', {
        attrs: {
          "text": _vm.currentRound.steps.find(function (_ref) {
            var id = _ref.id;
            return id === step.id;
          }).text,
          "text-step": _vm.currentRound.steps.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === step.id;
          })
        }
      })], 1);
    }), 0);
  }), 0), _c('div', {
    attrs: {
      "id": "img-overlay"
    }
  }, [_c('div', {
    attrs: {
      "id": "img-container"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Main image",
      "id": "img",
      "src": _vm.getImageSrc()
    }
  })])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }